<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style lang="scss">
  html,
  body {
    margin: 0;
    padding: 0;
  }

  .container_auto {
    width: 1300px;
    margin: 0 auto;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue